export default __webpack_public_path__ + "static/media/back.e188bbb8.jpg";